<template>
  <v-container>
    <v-tabs centered dark v-model="tab">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab v-for="item in tabItems" :key="item">
        {{ item }}
      </v-tab>
    </v-tabs>
    <v-tabs-items dark v-model="tab" style="background-color: transparent">
      <v-tab-item>
        <website-job-offers></website-job-offers>
      </v-tab-item>
      <v-tab-item>
        <website-services></website-services>
      </v-tab-item>
      <v-tab-item>
        <website-offers></website-offers>
      </v-tab-item>

      <v-tab-item v-if="userService.hasRight('g_websitecontent')">
        <v-card class="ma-md-5" flat color="transparent">
          <v-card-title class="white--text text-h5 font-weight-bold"> Studio Content verwalten </v-card-title>
          <v-card-subtitle class="white--text pb-4"> Wähle ein Studio aus der Liste oder nutze die Suche. </v-card-subtitle>

          <v-text-field
            v-model="searchQuery"
            label="Studio suchen..."
            filled
            rounded
            dense
            clearable
            prepend-inner-icon="mdi-magnify"
            class="mx-4 mb-4"
            hide-details></v-text-field>

          <v-container fluid>
            <v-row>
              <v-col v-for="studio of filteredStudios" :key="studio._id" cols="12" sm="6" md="4" lg="3">
                <v-card @click="openStudio(studio)" class="studio-card text-center" hover>
                  <div class="studio-card-icon-container">
                    <v-img
                      height="100"
                      contain
                      :src="`https://app.wellcomefit.ch/img/logos/studio/WELL-COME-FIT_LOGO_${studio.code.toUpperCase()}_BLACK.png`"
                      class="mb-2"></v-img>
                  </div>
                  <v-card-title class="justify-center white--text pt-3">
                    {{ studio.name }}
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
          </v-container>

          <v-alert v-if="filteredStudios.length === 0 && searchQuery" type="info" class="mx-4 mt-4" text>
            Kein Studio mit dem Namen "{{ searchQuery }}" gefunden.
          </v-alert>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <WebsiteContentDialog v-if="showDialog" :selectedStudio="selectedStudio" @close-dialog="showDialog = false" />
  </v-container>
</template>

<script>
import api from "@/api"
import WebsiteJobOffers from "./components/WebsiteJobOffers.vue"
import WebsiteContentDialog from "./components/WebsiteContentDialog.vue"
import WebsiteOffers from "./components/WebsiteOffers.vue"
import WebsiteServices from "./components/WebsiteServices.vue"
import WebsitePopups from "./components/WebsitePopups.vue"
import userService from "@/services/userService"

export default {
  components: { WebsiteContentDialog, WebsiteJobOffers, WebsiteOffers, WebsiteServices, WebsitePopups },
  data() {
    return {
      userService,
      studioList: [],
      jobs: [],
      tabItems: userService.hasRight("g_websitecontent") ? ["Jobs", "Leistungen", "Angebote", "Content"] : ["Jobs", "Leistungen", "Angebote"],
      tab: null,
      showDialog: false,
      selectedStudio: { name: "Bearbeiten", code: "", _id: "" },
      searchQuery: "", // NEU: Für die Live-Suche
    }
  },
  async created() {
    this.fetchStudios()
  },
  computed: {
    studioListSorted() {
      // Sortierung bleibt erhalten
      return [...this.studioList].sort((a, b) => a.name.localeCompare(b.name))
    },
    // NEU: Filtert die Studios basierend auf der Suche
    filteredStudios() {
      if (!this.searchQuery) {
        return this.studioListSorted
      }
      const lowerCaseQuery = this.searchQuery.toLowerCase().trim()
      return this.studioListSorted.filter((studio) => studio.name.toLowerCase().includes(lowerCaseQuery))
    },
  },
  methods: {
    async fetchStudios() {
      try {
        let studios = await api.fetchStudios()
        // Filterung wie bisher
        this.studioList = studios.filter((e) => e.code !== "alibey" && e.code !== "ot")
        this.fetchJobs()
      } catch (e) {
        this.$toast.error("Fehler beim Laden der Studios")
      }
    },
    showDetails(job) {
      this.$refs.newJobOffer.edit(job)
    },
    async fetchJobs() {
      try {
        let jobs = await api.fetchJobs()
        this.jobs = jobs
      } catch (e) {
        this.$toast.error("Fehler beim Laden der Jobs")
      }
    },
    openStudio(studio) {
      this.selectedStudio = { name: studio.name, code: studio.code, _id: studio._id }
      this.showDialog = true
    },
  },
}
</script>

<style scoped>
.studio-card {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border-radius: 12px !important;
  background: linear-gradient(145deg, #2a2a2a, #1e1e1e);
  box-shadow: 5px 5px 15px #1c1c1c, -5px -5px 15px #2e2e2e;
}

.studio-card:hover {
  transform: translateY(-5px);
  box-shadow: 8px 8px 20px #1c1c1c, -8px -8px 20px #2e2e2e;
}

.studio-card-icon-container {
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.05);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.v-tabs-items {
  background-color: transparent !important;
}

::v-deep .v-tabs-bar {
  background-color: transparent !important;
}
</style>
